import ResourceCard, { Bold, Title } from "./ResourceCard";
import { useQuickStartContext } from "./QuickStartCard";


export default function MarkdownResources() {
  const { programmingLanguage } = useQuickStartContext();

  return (
    <>
      <ResourceCard
        title={ <Title>Check out <Bold>how to get started</Bold></Title> }
        trackedTitle="Making requests"
        linkHref={ `https://docs.scraperapi.com/${programmingLanguage}` }
        tracked
      />

      <ResourceCard
        title={ <Title>Use the <Bold>API Endpoint Method</Bold></Title> }
        trackedTitle="API endpoint method"
        linkHref={ `https://docs.scraperapi.com/${programmingLanguage}/making-requests/api-endpoint-method` }
        tracked
      />

      <ResourceCard
        title={ <Title>Learn more about <Bold>LLM output formats</Bold></Title> }
        trackedTitle="LLM outputs"
        linkHref={ `https://docs.scraperapi.com/handling-and-processing-responses/output-formats/llm-output-formats` }
        tracked
      />
    </>
  );
};
